import { cn } from "@/lib/utils";

export function TwinMark({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden
      className={cn("shrink-0", className)}
      focusable="false"
      viewBox="0 0 32 32"
    >
      <circle cx="16" cy="16" fill="#D91B5C" r="13.2" />
      <circle cx="16" cy="16" fill="#E8501C" r="11.2" />
      <circle cx="16" cy="16" fill="#D49A00" r="9.2" />
      <circle cx="16" cy="16" fill="#00A56A" r="7.2" />
      <circle cx="16" cy="16" fill="#008FB8" r="5.2" />
      <circle cx="16" cy="16" fill="#7456E8" r="3.2" />
    </svg>
  );
}
